import React from "react";

export default function TermsOfService() {
  return (
    <main className="min-h-screen bg-[#0b0b0c] text-white">
      <div className="max-w-4xl mx-auto px-6 py-20">

        <h1 className="text-5xl font-bold text-[#ff8c08] mb-10">
          Terms of Service
        </h1>

        <div className="space-y-8 text-slate-300 leading-relaxed">

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using Filatom, you agree to comply with these
              Terms of Service and all applicable laws. If you do not agree,
              please discontinue use of the platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              2. Platform Overview
            </h2>
            <p>
              Filatom is a digital real estate platform that connects
              property owners, agents, buyers, renters, developers, and
              investors. Filatom does not directly own, sell, lease, or
              rent properties.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              3. Account Registration
            </h2>
            <p>
              Users may register using approved authentication methods.
              Users are responsible for maintaining the confidentiality
              of their account credentials and ensuring that all provided
              information is accurate.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              4. Property Listings
            </h2>
            <p>
              Users may publish property listings including homes, land,
              rentals, commercial properties, and related opportunities.
              Users are solely responsible for the accuracy and legality
              of their listings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              5. Agents & Sellers
            </h2>
            <p>
              Agents, brokers, and property owners must ensure they possess
              the legal authority to advertise, market, and transact on
              properties listed through Filatom.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              6. Transactions & Agreements
            </h2>
            <p>
              Filatom is not a party to agreements, negotiations, payments,
              contracts, or transactions between users. Users transact at
              their own discretion and risk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              7. User Conduct
            </h2>
            <p>
              Users must not publish fraudulent, deceptive, misleading,
              offensive, illegal, or unauthorized content. Violations may
              result in suspension or termination of access.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              8. Limitation of Liability
            </h2>
            <p>
              Filatom shall not be liable for disputes, damages, losses,
              claims, injuries, or costs arising from interactions,
              transactions, or agreements between users.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              9. Account Suspension & Termination
            </h2>
            <p>
              Filatom reserves the right to suspend, restrict, or permanently
              terminate user accounts that violate these terms or applicable
              laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">
              10. Changes To Terms
            </h2>
            <p>
              Filatom may modify these Terms of Service at any time.
              Continued use of the platform constitutes acceptance of
              updated terms.
            </p>
          </section>

          <div className="pt-8 border-t border-white/10">
            <p className="text-slate-500">
              Last Updated: June 2026
            </p>
          </div>

        </div>
      </div>
    </main>
  );
}